import { PicklistTableBase } from './PicklistTableBase';

export default PicklistTableBase;
